import React from 'react';
import { useLocation } from 'react-router-dom';

// antd
import { Affix } from 'antd';

// styling
import './index.less';

/**
 * @param {number} [affixOffsetTop=-32] Sticky offset from viewport top.
 * Default -32 preserves historical layout (Job Description tabs, etc.).
 * Work Status detail uses 60 so Update/Print sit below the fixed layout header.
 */
const PageHeaderContainer = ({
  header,
  children,
  showHeader = false,
  custom = false,
  pdemo = false,
  affixOffsetTop = -32,
}) => {
  const location = useLocation();

  let style = '';

  if (pdemo) {
    style = 'page-header-container-pdemo-content';
  } else if (custom) {
    style = 'page-header-container-custom-content';
  } else {
    style = 'page-header-container-content';
  }

  return (
    <div className="page-header-container">
      {(location.search !== '' || showHeader) && (
        <Affix offsetTop={affixOffsetTop}>{header}</Affix>
      )}
      <div className={style}>{children}</div>
    </div>
  );
};

export default PageHeaderContainer;
